"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderNoTrending = exports.renderTrendingDown = exports.renderTrendingUp = void 0;

var _react = _interopRequireDefault(require("react"));

require("./DataTable.css");

var _ArrowDownBoldIcon = _interopRequireDefault(require("mdi-react/ArrowDownBoldIcon"));

var _ArrowUpBoldIcon = _interopRequireDefault(require("mdi-react/ArrowUpBoldIcon"));

var _ArrowRightBoldIcon = _interopRequireDefault(require("mdi-react/ArrowRightBoldIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderTrendingUp = function renderTrendingUp(value) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ArrowUpBoldIcon.default, {
    color: "#0ec38f",
    className: "vs-table-trend-icon"
  }), value);
};

exports.renderTrendingUp = renderTrendingUp;

var renderTrendingDown = function renderTrendingDown(value) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ArrowDownBoldIcon.default, {
    color: "#f65161",
    className: "vs-table-trend-icon"
  }), value);
};

exports.renderTrendingDown = renderTrendingDown;

var renderNoTrending = function renderNoTrending(value) {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ArrowRightBoldIcon.default, {
    className: "vs-table-trend-icon"
  }), value);
};

exports.renderNoTrending = renderNoTrending;